<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/aboutUs/01/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="l-s-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="l-s-j-j-content">
                            <div class="title">
                                <span>{{l_s_j_j_form.title_1}}</span>
                                <span>{{l_s_j_j_form.title_2}}</span>
                            </div>
                            <p class="text">{{l_s_j_j_form.content_1}}</p>
                            <p class="text">{{l_s_j_j_form.content_2}}</p>
                            <p class="text">{{l_s_j_j_form.content_3}}</p>
                            <p class="text">{{l_s_j_j_form.content_4}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="q-y-w-h page-content-child" style="overflow:hidden ">
                <img :src="imgFor.bg" class="q-y-w-h-bg max-size" width="100%" data-fit-cover alt="" />
                    <div class="q-y-w-h-content">
                        <div class="title">企业文化</div>
                        <auto-row class="max-size list flew-row-wrap" style="overflow-x:hidden">
                            <auto-col class="list-item" v-for="(item,index) of q_y_w_h_list" :key="index">
                                <img :src="item.icon" class="q-y-w-h-icon"  height="48"  alt="">
                                <div class="titles">{{item.title}}</div>
                                <div class="texts">
                                    <p class="text" v-for="(text,index1) of item.texts" :key="index1">{{text}}</p>
                                </div>

                            </auto-col>
                        </auto-row>
                    </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    // require('@/assets/image/aboutUs/01/pic-1.png'),
                    require('@/assets/image/aboutUs/01/pic-2.png'),
                ],
                imgFor:{
                   bg:require('@/assets/image/aboutUs/01/qywh-bg.png'),
                },
                l_s_j_j_form:{ //朗数简介
                    title_1:'朗数',
                    title_2:'简介',
                    content_1:'武汉朗数科技有限公司（简称武汉朗数）成立于2013年，注册资本1000万，办公地点位于武汉高新区光谷企业天地2号楼。',
                    content_2:'武汉朗数致力于成为养老行业数字化建设与服务的领先者，以数字驱动健康，智慧赋能养老为愿景，通过融合大数据、人工智能、物联网、以及移动互联等创新技术，打造领先的数字化养老解决方案，实现端到端全场景的产品与服务覆盖，满足居家养老、社区养老、机构养老、家庭养老床位等多元养老业态需求，覆盖智慧城市养老数字化平台建设，为健康养老行业赋能。2022年成立浙江朗数科技有限公司（简称浙江朗数），并在浙江嘉兴设有办公中心，与行业内优秀的运营机构合作设立智慧养老实践基地，并与相关高校、咨询机构、行业协会、硬件厂商建立深入的合作关系，共同致力于推进健康养老行业的数字化发展。',
                    content_3:'武汉朗数也是一家有着企业级软件产品研发、行业软件项目实施、软件技术咨询服务、信息系统集成的高新技术企业。是国家高新技术企业，并通过美国CMMI研究院颁发的CMMI3级认证，目前已获得多项核心知识产权，拥有企业协同、智慧养老及企业级数据集成中间件等多款自主知识产权的产品。',
                    content_4:'公司旨在“技术创造价值”，坚持走技术路线，发扬“工匠精神”，拥有一支年轻充满朝气、多元化的团队，核心成员均是拥有超10年的互联网、物联网、大数据等技术经验，以及多年的养老、医疗等项目经验。'
                },
                q_y_w_h_list:[
                    {
                        title:'使命',
                        texts:['不止解决问题', ' 更致力于充分释放个个与组织潜能', ' 为社会进步和生活美好贡献智慧'],
                        icon:require('@/assets/image/aboutUs/01/sm.png'),
                    },
                    {
                        title:'价值观',
                        texts:['成就客户：客户优先、注重实效、长期发展', ' 专业：学习、精进、挑战', ' 真诚：正直、诚恳、用心', ' 团队：共情、分享、协作、担当', ' 以人为本：尊重、信任、赋能'],
                        icon:require('@/assets/image/aboutUs/01/jzg.png'),
                    },
                    {
                        title:'愿景',
                        texts:['打造具有影响力的百年智库'],
                        icon:require('@/assets/image/aboutUs/01/yj.png'),
                    }
                ]
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(2n+1){
        background-color:#ffffff;
    }
    .page-content-child:nth-child(2n+2){
        background-color: #F9F9F9;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }


    .l-s-j-j .l-s-j-j-content{
        text-align: center;
        padding:102px 0 216px 0;
    }


    .l-s-j-j .text{
        color:#333333;
        font-size: 24px;
        padding:30px 140px 0 140px;
        line-height: 1.6;
        text-align: left;
        transition: all .3s;
        text-indent: 2em;
    }

    .l-s-j-j .text:nth-of-type(1){
        padding-top:60px;
    }

    .l-s-j-j .text:hover{
        transform: translateY(-5px);
    }

    .q-y-w-h{
        position: relative;
    }

    .q-y-w-h .q-y-w-h-bg{
        height: 800px;
    }

    .q-y-w-h-content{
        position: absolute;
        top:0;
        left:0;
        right:0;
        bottom: 0;
        margin:auto auto;
    }

    .q-y-w-h .q-y-w-h-content .title{
        text-align: center;
        color:#FFFFFF;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
        margin-top:90px;
    }

    .q-y-w-h .list{
        width:calc(100% + 50px);
        text-align: left;
        margin-left: -25px;
        padding:0 10px;
    }

    .q-y-w-h .list-item{
        width:calc(33.33% - 50px);
        margin: 0 25px;
        margin-top:140px;
        text-align: center;
        transition: all .3s;
    }

    .q-y-w-h .list-item .titles{
        font-size: 30px;
        font-weight: 500;
        color: #FFFFFF;
        padding-top:5px;
    }

    .q-y-w-h .list-item .texts{
        text-align: center;
        margin-top: 56px;
        transition: all .3s;
    }

    .q-y-w-h .list-item .text{
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        width: 100%;
        margin: 0 auto;
    }

    .q-y-w-h .list-item .texts:hover{
        transform: translateY(-5px);
    }

    .q-y-w-h-icon{
        transition: .3s;
        transform: rotateY(0deg);
    }

    .q-y-w-h .list-item .q-y-w-h-icon:hover{
        transform: rotateY(180deg) !important;
    }


    /*.q-y-w-h-icon:hover{*/
    /*    transform: rotateY(180deg);*/
    /*}*/




    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .l-s-j-j .l-s-j-j-content{
            text-align: center;
            padding:100px 0 180px 0;
        }

        .l-s-j-j .text{
            padding:30px 100px 0 100px;
        }

    }

    @media screen and (max-width: 960px){
        .l-s-j-j .l-s-j-j-content{
            text-align: center;
            padding:90px 0 160px 0;
        }

        .l-s-j-j .text{
            padding:30px 60px 0 60px;
        }

        .q-y-w-h .list-item{
            margin-top:100px;
        }

        .q-y-w-h .list-item .texts{
            margin-top: 40px;
        }

    }

    @media screen and (max-width: 760px){
        .l-s-j-j .l-s-j-j-content{
            text-align: center;
            padding:80px 0 100px 0;
        }

        .l-s-j-j .text{
            padding:30px 10px 0 10px;
        }

        .q-y-w-h .list-item{
            margin-top:60px;
        }

        .q-y-w-h .list-item .texts{
            margin-top: 30px;
        }
    }
</style>
